<main>
	<header>
		<span>
			<strong>{{ moduleName$ | async }}</strong>
			<small>
				<current-location-icon />
				{{ requestPoint() }}
			</small>
		</span>
		<ng-content />
	</header>
	<section>
		<router-outlet />
	</section>
</main>
